import api from "../../api";
import { PageContent, Breadcrumbs, PreLoader, ConferenceCardList, ConferenceCard } from "../../components";
import { useState, useEffect } from "react";

const ConferencesList = () => {
    const [loading, setLoading] = useState(false);
    const [conferences, setConferences] = useState([])
    useEffect(() => {
        setLoading(true);
        api.getConferences()
            .then((data) => {
                setLoading(false);
                setConferences(data);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }, []);
    const titleName = 'Отчеты о конференциях'
    return (
        <>
            {loading ? (
                <PreLoader />
            ) : (
                <PageContent title={titleName}>
                    <Breadcrumbs urls={[{ title: titleName, path: '' }]} />
                    <ConferenceCardList>
                        {conferences.results?.map((card) => <ConferenceCard
                            {...card}
                            key={card.id}
                        />)}
                    </ConferenceCardList>
                </PageContent>
            )}
        </>
    );
}

export default ConferencesList;